import r from "./restArguments.js";
import t from "./isFunction.js";
import n from "./_executeBound.js";
var o = r(function (o, e, i) {
  if (!t(o)) throw TypeError("Bind must be called on a function");
  var u = r(function (r) {
    return n(o, u, e, this, i.concat(r));
  });
  return u;
});
export { o as default };